import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import AdduserModal from "../../Modal/AdduserModal";
import UserTable from "./UserTable";
import { useDispatch, useSelector } from "react-redux";
import { APIUtility } from "../../Api";
import { setUserData, setUserRoles } from "../../Redux/CommonSlice/allDataSlice";
import { Search } from "lucide-react";
import { debounce } from "lodash";
import { Plus } from "lucide-react";

const Users = () => {
  const [showAdduserModal, setShowAdduserModal] = useState(false);
  const [isEditUser, setIsEditUser] = useState(false);
  const [EditData, setEditData] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const auth = useSelector((state) => state.auth);
  const { permissions } = auth?.user?.user_permissions || {}

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const response = await APIUtility.GetUser();
      if (response.status === 200 || response.status === 201) {
        dispatch(setUserData(response.data.users));
        dispatch(setUserRoles(response.data.roles));
        setIsLoading(false);
      } else {
        setIsLoading(false);
        dispatch(setUserData([]));
        dispatch(setUserRoles([]));
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Failed to fetch users:", error);
      dispatch(setUserData([]));
      dispatch(setUserRoles([]));
    }
  };

  useEffect(() => {
    fetchUsers();
    setIsEditUser(false);
  }, [dispatch]);

  const handleSearch = useCallback(
    debounce((query) => {
      setSearchQuery(query);
    }, 300),
    []
  );

  return (
    <div className="p-6">
      <div className="mb-4 w-full flex justify-between">
        <div className="text-gray-400 text-lg font-semibold">Users</div>
        <div className="relative flex items-center">
          <Search
            className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 pointer-events-none"
            color="#999999"
          />
          <input
            type="text"
            placeholder="Search User Here"
            className="pl-10 pr-4 py-2 border rounded w-[415px] h-[45px]"
            style={{ paddingLeft: "2.5rem" }}
            onChange={(e) => handleSearch(e.target.value)}
          />
          {
            permissions?.user_add_button && <button
            type="button"
            className="ml-4 border px-[0.8rem] py-2 rounded-[3px] bg-green-500 text-white gap-2 flex items-center"
            onClick={() => {
              setIsEditUser({});
              setIsEditUser(false);
              setShowAdduserModal(true);
            }}
          >
            <Plus color="#FFFFFF" />
            <span>Add User</span>
          </button>
          }
     
        </div>
      </div>

      <AdduserModal
        show={showAdduserModal}
        onHide={() => setShowAdduserModal(false)}
        isEditUser={isEditUser}
        EditData={EditData}
        setIsEditUser={setIsEditUser}
        fetchUsers={fetchUsers}
      />

      <UserTable
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setShowAdduserModal={setShowAdduserModal}
        isEditUser={isEditUser}
        setIsEditUser={setIsEditUser}
        setEditData={setEditData}
        fetchUsers={fetchUsers}
        searchQuery={searchQuery} // Pass searchQuery as a prop
        permissions={permissions}
      />

    </div>
  );
};

export default Users;
